/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

return 5;
}

export default ["qu",[["a.m.","p.m."]],u,[["D","L","M","X","J","V","S"],["Dom","Lun","Mar","Mié","Jue","Vie","Sab"],["Domingo","Lunes","Martes","Miércoles","Jueves","Viernes","Sábado"],["Dom","Lun","Mar","Mié","Jue","Vie","Sab"]],u,[["1","2","3","4","5","6","7","8","9","10","11","12"],["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Set","Oct","Nov","Dic"],["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Setiembre","Octubre","Noviembre","Diciembre"]],u,[["a.d.","dC"],["a.d.","d.C."],["ñawpa cristu","chanta cristu"]],0,[6,0],["d/M/yy","d MMM y","d MMMM y","EEEE, d MMMM, y"],["h:mm a","h:mm:ss a","h:mm:ss a z","h:mm:ss a zzzz"],["{1} {0}",u,"{0} {1}","{1} {0}"],[".",",",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##0.###","#,##0 %","¤ #,##0.00","#E0"],"PEN","S/","Sol Peruano",{"BBD":["BBG","$"],"BMD":["DBM","$"],"BZD":["DBZ","$"],"CAD":["$CA","$"],"GHS":[u,"GHC"],"JPY":["JP¥","¥"],"PEN":["S/"],"PHP":[u,"₱"],"USD":["$US","$"]},"ltr", plural];
